import ContractOffer from 'application/src/js/market/trade-items/contract-offer.js';
export default ContractOffer;